import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary as EBoundaryComponent } from 'react-error-boundary'
import ErrorFallback from './ErrorFallback'

export default function ErrorBoundary({ children }) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <EBoundaryComponent onReset={reset} FallbackComponent={ErrorFallback}>
          {children}
        </EBoundaryComponent>
      )}
    </QueryErrorResetBoundary>
  )
}
